<template>
  <v-hover v-slot="{ hover }">
    <div>
        <template>
          <v-card class="pa-1 mb-1 application-container"
                  :elevation="hover ? 8 : 2"
                  :class="{ 'on-hover': hover }"
                  role="button"
                  tabindex="0"
                  @click="showChanges = true"
                  @keydown.enter="showChanges = true"
                  @keydown.space.prevent="showChanges = true">
            <div class="title-container">
              <div class="description">
                <v-card-title class="title">
                  {{ application }}
                </v-card-title>
                <div class="change-summary">
                  <v-card-subtitle class="subtitle">
                    Unreleased Commits: {{ changeCount }}
                  </v-card-subtitle>
                  <div v-if="contributors.length" class="contributors" aria-label="Contributors">
                    <v-tooltip bottom v-for="contributor in contributors" :key="contributor.id">
                      <template v-slot:activator="{ on }">
                        <v-avatar size="28" class="contributor-avatar" v-on="on">
                          <img :src="contributor.avatarUrl" :alt="contributor.displayName">
                        </v-avatar>
                      </template>
                      <span>{{ contributor.displayName }}</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
              <v-btn icon small class="ignore-btn" :aria-label="ignored ? 'Unignore' : 'Ignore'"
                :title="ignored ? 'Unignore' : 'Ignore'" @click.stop="$emit(ignored ? 'unignore' : 'ignore')">
                <v-icon small>{{ ignored ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
              </v-btn>
            </div>

          </v-card>
          <CommitChangesDialog v-model="showChanges" :title="`${application} unreleased changes`" :changes="changes" />
        </template>
    </div>
  </v-hover>
</template>

<script>
import CommitChangesDialog from './CommitChangesDialog.vue';

export default {
  name: 'SimpleApplicationView',
  components: { CommitChangesDialog },
  data() {
    return {
      showChanges: false
    }
  },
  props: {
    application: String,
    changeCount: Number,
    contributors: {
      type: Array,
      default: () => []
    },
    changes: {
      type: Array,
      default: () => []
    },
    ignored: Boolean
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.application-container {
  position: relative;
  text-align: left;
  cursor: pointer;
}

.application-container .title-container {
  display: flex;
  align-items: center;
}

.application-container .title-container .title {
  padding-bottom: 0;
}

.application-container .title-container .description {
  flex-grow: 1;
}
.application-container .edit-btn {
  padding: 32px;
}

.ignore-btn {
  position: absolute;
  top: 6px;
  right: 6px;
}

.application-container .title {
  color: #e7a34d;
  font-weight: bold;
}

.subtitle {
  text-align: left;
}

.change-summary {
  display: flex;
  align-items: center;
  padding-right: 16px;
}

.change-summary .subtitle {
  flex-grow: 1;
}

.contributors {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.contributor-avatar {
  border: 2px solid white;
}

.contributor-avatar + .contributor-avatar {
  margin-left: -8px;
}


.expandable-title {
  min-height: 64px;
}

.v-expansion-panel-header--active,
.expandable-title:hover {
  color: #42b983;
}

.v-expansion-panel-header .subtitle {
  line-height: 24px;
  font-size: 0.9em;
  color: rgba(0, 0, 0, 0.6);
}

.v-expansion-panel-header--active:before {
  color: inherit;
}

.expandable-content .expandable-content-container {
  padding: 0 0 0 18px;
}


.dialog-container .title-container .title {
  padding: 36px 48px 0;
}

.dialog-container h2 {
  text-align: left;
}

.dialog-container .configuration-container {
  text-align: left;
}

.dialog-container .environment-configuration-container {
  margin: 0 24px 24px;
}

.dialog-container .environment-configuration-container .v-subheader {
  height: auto;
  margin-top: 12px;
}

.dialog-container .environment-configuration-container h3 {
  color: #42b983;
  font-size: x-large;
}

.dialog-container .environment-configuration-container .select-input {
  padding: 0;
}


.dialog-container .environment-configuration-container .header {
  display: flex;
  align-items: center;
}


.dialog-container .environment-configuration-container .header h3 {
  flex-grow: 1;
}

.dialog-container .v-card__actions {
  padding: 24px;
}

.environment-configuration-divider {
  display: none;
}

.environment-configuration-group-divider + .environment-configuration-information-container > div:first-child .environment-configuration-divider {
  display: block;
  width: 100%;
  height: 1px;
  margin: 15px 0;
  background-color: #dcdee0;
}

</style>
